import { render, staticRenderFns } from "./BWSelect.vue?vue&type=template&id=92ee5b1a"
import script from "./BWSelect.vue?vue&type=script&lang=js"
export * from "./BWSelect.vue?vue&type=script&lang=js"
import style0 from "./BWSelect.vue?vue&type=style&index=0&id=92ee5b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports